var map = {
	"./Icon-Blue.svg": 1115,
	"./Icon-White.svg": 1116,
	"./Logo-Dark.svg": 1117,
	"./Logo-Light.svg": 1118,
	"./Logo-Tagline-Dark.svg": 1119,
	"./Logo-Tagline-Light.svg": 1120,
	"./Logo-Tagline-White.svg": 1121,
	"./Logo-White.svg": 1122,
	"./activity--active.svg": 1123,
	"./activity.svg": 1124,
	"./add-item.svg": 1125,
	"./add-to-qbank.svg": 1126,
	"./agreements-active.svg": 1127,
	"./agreements.svg": 1128,
	"./alien-color.svg": 1129,
	"./alien-monster.svg": 1130,
	"./align-center.svg": 1131,
	"./align-justify.svg": 1132,
	"./align-left.svg": 1133,
	"./align-right.svg": 1134,
	"./apps-active.svg": 1135,
	"./apps.svg": 1136,
	"./badge.svg": 1137,
	"./bell-active.svg": 1138,
	"./bell-linear.svg": 1139,
	"./bell.svg": 1140,
	"./billing-active.svg": 1141,
	"./billing.svg": 1142,
	"./bold.svg": 1143,
	"./bug.svg": 1144,
	"./calendar-day.svg": 1145,
	"./calender.svg": 1146,
	"./check-circle.svg": 1147,
	"./check-square.svg": 1148,
	"./check.svg": 1149,
	"./clock.svg": 1150,
	"./close-circle.svg": 1151,
	"./cloud-upload-black.svg": 1152,
	"./cloud-upload.svg": 1153,
	"./collapse-sidemenu.svg": 1154,
	"./color/app-excel-disabled.svg": 1155,
	"./color/app-excel.svg": 1156,
	"./color/app-pdf.svg": 1157,
	"./color/app-word.svg": 1158,
	"./color/ball-pile-colourful.svg": 1159,
	"./color/ball-pile-gray.svg": 1160,
	"./color/box-colourful.svg": 1161,
	"./color/box-gray.svg": 1162,
	"./color/box-usd-colourful.svg": 1163,
	"./color/box-usd-gray.svg": 1164,
	"./color/briefcase-colourful.svg": 1165,
	"./color/briefcase-gray.svg": 1166,
	"./color/bug-colourful.svg": 1167,
	"./color/bug-gray.svg": 1168,
	"./color/building-colourful.svg": 1169,
	"./color/building-gray.svg": 1170,
	"./color/chevron-double-left-colourful.svg": 1171,
	"./color/chevron-double-left-gray.svg": 1172,
	"./color/chevron-double-right-colourful.svg": 1173,
	"./color/chevron-double-right-gray.svg": 1174,
	"./color/clipboard-colourful.svg": 1175,
	"./color/clipboard-gray.svg": 1176,
	"./color/cog-colourful.svg": 1177,
	"./color/cog-gray.svg": 1178,
	"./color/file-colourful.svg": 1179,
	"./color/file-contract-colourful.svg": 1180,
	"./color/file-contract-gray.svg": 1181,
	"./color/file-gray.svg": 1182,
	"./color/file-types-api.svg": 1183,
	"./color/file-types-apk.svg": 1184,
	"./color/file-types-ipa.svg": 1185,
	"./color/file-types-json.svg": 1186,
	"./color/file-types-mov.svg": 1187,
	"./color/file-types-mp-4.svg": 1188,
	"./color/file-types-pdf.svg": 1189,
	"./color/flag-colourful.svg": 1190,
	"./color/flag-gray.svg": 1191,
	"./color/folder-open-colourful.svg": 1192,
	"./color/folder-open-gray.svg": 1193,
	"./color/fundraiser.svg": 1194,
	"./color/gmail.svg": 1195,
	"./color/handshake-colourful.svg": 1196,
	"./color/handshake-gray.svg": 1197,
	"./color/home-colourful.svg": 1198,
	"./color/home-gray.svg": 1199,
	"./color/layout-1col.svg": 1200,
	"./color/layout-2col.svg": 1201,
	"./color/layout-3col.svg": 1202,
	"./color/list-alt-colourful.svg": 1203,
	"./color/list-alt-gray.svg": 1204,
	"./color/list-colourful.svg": 1205,
	"./color/list-gray.svg": 1206,
	"./color/megaphone-colourful.svg": 1207,
	"./color/megaphone-gray.svg": 1208,
	"./color/mobile-colourful.svg": 1209,
	"./color/mobile-gray.svg": 1210,
	"./color/outlook.svg": 1211,
	"./color/page-break.svg": 1212,
	"./color/pie-chart-colourful.svg": 1213,
	"./color/pie-chart-gray.svg": 1214,
	"./color/plus-oval.svg": 1215,
	"./color/question-bank-colourful.svg": 1216,
	"./color/question-bank-gray.svg": 1217,
	"./color/rectangle.svg": 1218,
	"./color/tiles-colourful.svg": 1219,
	"./color/tiles-gray.svg": 1220,
	"./color/truck-colourful.svg": 1221,
	"./color/truck-gray.svg": 1222,
	"./color/usd-circle-colourful.svg": 1223,
	"./color/usd-circle-gray.svg": 1224,
	"./color/user-check-colourful.svg": 1225,
	"./color/user-check-gray.svg": 1226,
	"./color/user-cog-colourful.svg": 1227,
	"./color/user-cog-gray.svg": 1228,
	"./color/user-friend-colourful.svg": 1229,
	"./color/user-friend-gray.svg": 1230,
	"./color/users-crown-colourful.svg": 1231,
	"./color/users-crown-gray.svg": 1232,
	"./comment-alt.svg": 1233,
	"./comment-exclamation.svg": 1234,
	"./comment-linear.svg": 1235,
	"./comment.svg": 1236,
	"./company-details-active.svg": 1237,
	"./company-details.svg": 1238,
	"./company-projects-active.svg": 1239,
	"./company-projects.svg": 1240,
	"./company-team-active.svg": 1241,
	"./company-team.svg": 1242,
	"./date.svg": 1243,
	"./devices-active.svg": 1244,
	"./devices.svg": 1245,
	"./dialpad.svg": 1246,
	"./distribution-active.svg": 1247,
	"./distribution.svg": 1248,
	"./document-2.svg": 1249,
	"./documents-active.svg": 1250,
	"./documents.svg": 1251,
	"./down.svg": 1252,
	"./dropdown-arrow-down.svg": 1253,
	"./dustbin.svg": 1254,
	"./email.svg": 1255,
	"./exclamation.svg": 1256,
	"./expand.svg": 1257,
	"./fill-drip.svg": 1258,
	"./filled.svg": 1259,
	"./filled/add-to-bank.svg": 1260,
	"./filled/archive.svg": 1261,
	"./filled/arrow-alt-down.svg": 1262,
	"./filled/arrow-alt-up.svg": 1263,
	"./filled/arrow-down.svg": 1264,
	"./filled/arrow-left.svg": 1265,
	"./filled/arrow-right.svg": 1266,
	"./filled/arrow-up.svg": 1267,
	"./filled/ball-pile-minus.svg": 1268,
	"./filled/ball-pile-pencil.svg": 1269,
	"./filled/ball-pile-plus.svg": 1270,
	"./filled/ball-pile.svg": 1271,
	"./filled/barcode.svg": 1272,
	"./filled/bell.svg": 1273,
	"./filled/bitcoin.svg": 1274,
	"./filled/box-minus.svg": 1275,
	"./filled/box-pencil.svg": 1276,
	"./filled/box-plus-alt.svg": 1277,
	"./filled/box-plus.svg": 1278,
	"./filled/briefcase.svg": 1279,
	"./filled/bug.svg": 1280,
	"./filled/building.svg": 1281,
	"./filled/calendar.svg": 1282,
	"./filled/camera.svg": 1283,
	"./filled/chart-bar.svg": 1284,
	"./filled/chart-column.svg": 1285,
	"./filled/chart-doughnut.svg": 1286,
	"./filled/chart-pie.svg": 1287,
	"./filled/check-circle.svg": 1288,
	"./filled/check-mark.svg": 1289,
	"./filled/chevron-down.svg": 1290,
	"./filled/chevron-left.svg": 1291,
	"./filled/chevron-right.svg": 1292,
	"./filled/chevron-up.svg": 1293,
	"./filled/circle.svg": 1294,
	"./filled/clipboard-list-check.svg": 1295,
	"./filled/clock.svg": 1296,
	"./filled/close-circle.svg": 1297,
	"./filled/close.svg": 1298,
	"./filled/cloud-upload.svg": 1299,
	"./filled/cog-minus.svg": 1300,
	"./filled/cog-pencil.svg": 1301,
	"./filled/cog-plus.svg": 1302,
	"./filled/cog.svg": 1303,
	"./filled/cohort.svg": 1304,
	"./filled/comment-alt.svg": 1305,
	"./filled/comment-exclamation.svg": 1306,
	"./filled/comment.svg": 1307,
	"./filled/compass-rocket.svg": 1308,
	"./filled/do-not-enter.svg": 1309,
	"./filled/duplicate.svg": 1310,
	"./filled/ellipsis.svg": 1311,
	"./filled/envelope.svg": 1312,
	"./filled/equals.svg": 1313,
	"./filled/exclamation-circle.svg": 1314,
	"./filled/exclamation-triangle.svg": 1315,
	"./filled/external-link.svg": 1316,
	"./filled/eye-slash.svg": 1317,
	"./filled/eye.svg": 1318,
	"./filled/feather.svg": 1319,
	"./filled/file-contract.svg": 1320,
	"./filled/file-csv.svg": 1321,
	"./filled/file-edit.svg": 1322,
	"./filled/file-minus.svg": 1323,
	"./filled/file-plus.svg": 1324,
	"./filled/file-signature.svg": 1325,
	"./filled/file.svg": 1326,
	"./filled/filter.svg": 1327,
	"./filled/flag-plus.svg": 1328,
	"./filled/flag.svg": 1329,
	"./filled/folder-edit.svg": 1330,
	"./filled/folder-plus.svg": 1331,
	"./filled/gift.svg": 1332,
	"./filled/heart.svg": 1333,
	"./filled/home.svg": 1334,
	"./filled/icon-box-usd.svg": 1335,
	"./filled/id-badge.svg": 1336,
	"./filled/image-landscape.svg": 1337,
	"./filled/image.svg": 1338,
	"./filled/info-circle.svg": 1339,
	"./filled/jira.svg": 1340,
	"./filled/life-ring.svg": 1341,
	"./filled/link.svg": 1342,
	"./filled/list.svg": 1343,
	"./filled/log-out.svg": 1344,
	"./filled/marketplace.svg": 1345,
	"./filled/menu.svg": 1346,
	"./filled/message-check.svg": 1347,
	"./filled/message-double-check.svg": 1348,
	"./filled/oval.svg": 1349,
	"./filled/page-break.svg": 1350,
	"./filled/pencil.svg": 1351,
	"./filled/phone.svg": 1352,
	"./filled/play.svg": 1353,
	"./filled/plus.svg": 1354,
	"./filled/print.svg": 1355,
	"./filled/puzzle-piece.svg": 1356,
	"./filled/question-bank.svg": 1357,
	"./filled/question.svg": 1358,
	"./filled/radio-button.svg": 1359,
	"./filled/redo.svg": 1360,
	"./filled/reorder.svg": 1361,
	"./filled/resizing.svg": 1362,
	"./filled/section-break.svg": 1363,
	"./filled/sign-out-left.svg": 1364,
	"./filled/smile.svg": 1365,
	"./filled/star-half.svg": 1366,
	"./filled/star.svg": 1367,
	"./filled/support.svg": 1368,
	"./filled/sync.svg": 1369,
	"./filled/thumbs-down.svg": 1370,
	"./filled/thumbs-up.svg": 1371,
	"./filled/thumbtack.svg": 1372,
	"./filled/trash.svg": 1373,
	"./filled/truck.svg": 1374,
	"./filled/undo.svg": 1375,
	"./filled/user-cog.svg": 1376,
	"./filled/user-edit.svg": 1377,
	"./filled/user-friend.svg": 1378,
	"./filled/user-minus.svg": 1379,
	"./filled/user-plus.svg": 1380,
	"./filled/user.svg": 1381,
	"./filled/video.svg": 1382,
	"./filled/window.svg": 1383,
	"./flag--active.svg": 1384,
	"./flag.svg": 1385,
	"./focusgroup-active.svg": 1386,
	"./focusgroup.svg": 1387,
	"./font.svg": 1388,
	"./format-align-center.svg": 1389,
	"./format-align-justify.svg": 1390,
	"./format-align-left.svg": 1391,
	"./format-align-right.svg": 1392,
	"./format-bold.svg": 1393,
	"./format-fill.svg": 1394,
	"./format-font.svg": 1395,
	"./format-indent-left.svg": 1396,
	"./format-indent-right.svg": 1397,
	"./format-italic.svg": 1398,
	"./format-list-bullet.svg": 1399,
	"./format-list-numbers.svg": 1400,
	"./format-remove.svg": 1401,
	"./format-text-size.svg": 1402,
	"./format-tint-slash.svg": 1403,
	"./format-underline.svg": 1404,
	"./gray.svg": 1405,
	"./grid-icon.svg": 1406,
	"./home-active.svg": 1407,
	"./home.svg": 1408,
	"./italic.svg": 1409,
	"./large-drag-drop.svg": 1410,
	"./letter.svg": 1411,
	"./life-ring.svg": 1412,
	"./linear/bell.svg": 1413,
	"./linear/box.svg": 1414,
	"./linear/calendar-day.svg": 1415,
	"./linear/check-circle.svg": 1416,
	"./linear/check-square.svg": 1417,
	"./linear/comment.svg": 1418,
	"./linear/dial-pad.svg": 1419,
	"./linear/expand.svg": 1420,
	"./linear/format-align-center.svg": 1421,
	"./linear/format-align-justify.svg": 1422,
	"./linear/format-align-left.svg": 1423,
	"./linear/format-align-right.svg": 1424,
	"./linear/format-bold.svg": 1425,
	"./linear/format-fill-drip.svg": 1426,
	"./linear/format-font.svg": 1427,
	"./linear/format-indent-left.svg": 1428,
	"./linear/format-indent-right.svg": 1429,
	"./linear/format-italic.svg": 1430,
	"./linear/format-list-bullet.svg": 1431,
	"./linear/format-list-numbers.svg": 1432,
	"./linear/format-remove-format.svg": 1433,
	"./linear/format-text-size.svg": 1434,
	"./linear/format-tint-slash.svg": 1435,
	"./linear/format-underline.svg": 1436,
	"./linear/globe.svg": 1437,
	"./linear/matrix-caret.svg": 1438,
	"./linear/matrix-checkbox.svg": 1439,
	"./linear/matrix-radio.svg": 1440,
	"./linear/minus.svg": 1441,
	"./linear/mobile.svg": 1442,
	"./linear/paperclip.svg": 1443,
	"./linear/phone.svg": 1444,
	"./linear/project-diagram.svg": 1445,
	"./linear/pulse.svg": 1446,
	"./linear/search-minus.svg": 1447,
	"./linear/search-plus.svg": 1448,
	"./linear/search.svg": 1449,
	"./linear/smile-wink.svg": 1450,
	"./linear/smile.svg": 1451,
	"./linear/star.svg": 1452,
	"./linear/tablet-landscape.svg": 1453,
	"./linear/tablet-portrait.svg": 1454,
	"./linear/text.svg": 1455,
	"./linear/trash.svg": 1456,
	"./link.svg": 1457,
	"./list-bullet.svg": 1458,
	"./list-numbers.svg": 1459,
	"./log-out.svg": 1460,
	"./matrix-caret.svg": 1461,
	"./matrix-checkbox.svg": 1462,
	"./matrix-radio.svg": 1463,
	"./menu-collapse-right.svg": 1464,
	"./menu.svg": 1465,
	"./message-check.svg": 1466,
	"./message-linear.svg": 1467,
	"./milestones-active.svg": 1468,
	"./milestones.svg": 1469,
	"./minus.svg": 1470,
	"./note.svg": 1471,
	"./notice-active.svg": 1472,
	"./notice.svg": 1473,
	"./opportunities-active.svg": 1474,
	"./paperclip.svg": 1475,
	"./person-add.svg": 1476,
	"./phone-linear.svg": 1477,
	"./phone.svg": 1478,
	"./plan-active.svg": 1479,
	"./plan.svg": 1480,
	"./plus.svg": 1481,
	"./products-active.svg": 1482,
	"./products.svg": 1483,
	"./project-diagram.svg": 1484,
	"./pulse-linear.svg": 1485,
	"./questionBank-active.svg": 1486,
	"./questionBank.svg": 1487,
	"./redo.svg": 1488,
	"./reminder--active.svg": 1489,
	"./reminder-opportunity.svg": 1490,
	"./reminder-survey.svg": 1491,
	"./reminder-unfinished-survey.svg": 1492,
	"./reminder.svg": 1493,
	"./right.svg": 1494,
	"./search-minus.svg": 1495,
	"./search-plus.svg": 1496,
	"./search.svg": 1497,
	"./setting-active.svg": 1498,
	"./setting.svg": 1499,
	"./slab.svg": 1500,
	"./smile-linear.svg": 1501,
	"./smile-wink.svg": 1502,
	"./star-linear.svg": 1503,
	"./surveys-active.svg": 1504,
	"./surveys.svg": 1505,
	"./team-active.svg": 1506,
	"./team.svg": 1507,
	"./templates.svg": 1508,
	"./tester-active.svg": 1509,
	"./tester.svg": 1510,
	"./text-size.svg": 1511,
	"./text.svg": 1512,
	"./thin/barcode.svg": 1513,
	"./thin/button.svg": 1514,
	"./thin/child-form.svg": 1515,
	"./thin/date-time.svg": 1516,
	"./thin/desktop.svg": 1517,
	"./thin/divider.svg": 1518,
	"./thin/dragdrop.svg": 1519,
	"./thin/file-upload.svg": 1520,
	"./thin/icon-lock.svg": 1521,
	"./thin/image.svg": 1522,
	"./thin/location.svg": 1523,
	"./thin/mobile.svg": 1524,
	"./thin/photo.svg": 1525,
	"./thin/profile.svg": 1526,
	"./thin/question.svg": 1527,
	"./thin/signature.svg": 1528,
	"./thin/tablet.svg": 1529,
	"./thin/text.svg": 1530,
	"./thin/video.svg": 1531,
	"./thin/web.svg": 1532,
	"./three-users.svg": 1533,
	"./trash-linear.svg": 1534,
	"./underline.svg": 1535,
	"./undo.svg": 1536,
	"./up.svg": 1537,
	"./upload-pdf.svg": 1538,
	"./user-check.svg": 1539,
	"./user-clock.svg": 1540,
	"./user-cog.svg": 1541,
	"./user.svg": 1542,
	"./vyoo-logo.svg": 1543,
	"./wide-survey-active.svg": 1544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1114;